import { AfterViewInit, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClientService } from 'app/services/client-service';
import { PolicyService } from 'app/services/policy-service';
import { ChatService } from 'app/services/chat-service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/security/auth.service';
import { CommonsText } from 'app/commons/CommonsText';
import { CommonsUtils } from 'app/commons/CommonsUtils';
var ProfilePageComponent = /** @class */ (function () {
    function ProfilePageComponent(clientService, policyService, chatService, toastr, authService, route, renderer, document) {
        this.clientService = clientService;
        this.policyService = policyService;
        this.chatService = chatService;
        this.toastr = toastr;
        this.authService = authService;
        this.route = route;
        this.renderer = renderer;
        this.document = document;
        // Arrancan en true porque ngAfterViewInit es quien lanza las cargas: si empezaran en false,
        // la vista ya se habria comprobado con ese valor y el cambio a true dentro del hook provoca
        // un ExpressionChangedAfterItHasBeenCheckedError sobre el *ngIf del "Cargando...".
        this.loadingProfile = true;
        this.loadingPayment = true;
        this.showDirectAreas = true;
        this.isTaker = false;
        this.isCompany = false;
        this.roadTypeList = [];
        this.activeOption = 'profile';
        /**
         * Respaldo mientras no han llegado los datos de cliente: el nombre del token, que se fija
         * al iniciar sesion.
         */
        this.tokenFullName = '';
        this.userEmail = '';
        this.editing = false;
        this.hasLegalAssistanceProduct = false;
    }
    ProfilePageComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.authService.isLogged()) {
            this.showDirectAreas = this.authService.getSelectedEntity() === 'ONLYGAL';
            this.loadTakerSummary();
            this.loadLegalAssistanceProduct();
        }
        var u = this.authService.getUser();
        if (u) {
            this.tokenFullName = ((u.name || '') + ' ' + (u.lastName || '')).trim();
            this.userEmail = u.email || '';
            this.isCompany = !!(u.documentType && u.documentType === 'CIF');
        }
        // Suscrito y no leido del snapshot: por debajo de $md la barra lateral solo muestra nombre y correo,
        // asi que se cambia de seccion desde el menu de usuario de la cabecera, que navega a
        // /profile con otro ?section= y Angular reutiliza este mismo componente sin volver a pasar
        // por ngOnInit.
        this.sectionSub = this.route.queryParamMap.subscribe(function (params) {
            var section = params.get('section');
            if (section) {
                _this.activeOption = section;
            }
        });
        this.clientService.getRoadTypes()
            .then(function (value) {
            _this.roadTypeList = value.response;
        })
            .catch(function () {
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_TIPO_D_VIA, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    Object.defineProperty(ProfilePageComponent.prototype, "userFullName", {
        /**
         * Se compone de los datos de cliente y no del token: asi incluye el primer apellido y se
         * refresca solo al editar el perfil, porque this.client es el mismo objeto que ClientService
         * actualiza al guardar.
         */
        get: function () {
            return CommonsUtils.fullName(this.client) || this.tokenFullName;
        },
        enumerable: true,
        configurable: true
    });
    ProfilePageComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.loadingProfile = true;
        this.loadingPayment = true;
        this.clientService.getClient()
            .then(function (success) {
            _this.loadingProfile = false;
            _this.profileResponse = success;
            _this.client = success;
            if (success && success.email && !_this.userEmail) {
                _this.userEmail = success.email;
            }
        })
            .catch(function () {
            _this.loadingProfile = false;
            _this.profileResponse = null;
            _this.client = null;
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_CLIENTE, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
        this.clientService.getPayment()
            .then(function (success) {
            _this.loadingPayment = false;
            _this.paymentResponse = success.response;
        })
            .catch(function () {
            _this.loadingPayment = false;
            _this.paymentResponse = null;
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_CLIENTE, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    /** Relación del cliente con sus pólizas; la barra lateral la usa para "Consentimiento". */
    ProfilePageComponent.prototype.loadTakerSummary = function () {
        var _this = this;
        this.policyService.isTaker()
            .then(function (is) { _this.isTaker = is; });
    };
    ProfilePageComponent.prototype.loadLegalAssistanceProduct = function () {
        var _this = this;
        this.policyService.hasLegalAssistanceProduct()
            .then(function (has) {
            _this.hasLegalAssistanceProduct = has;
            if (has) {
                _this.chatService.ensureWidgetLoaded();
            }
        })
            .catch(function () {
            _this.hasLegalAssistanceProduct = false;
        });
    };
    ProfilePageComponent.prototype.ngOnDestroy = function () {
        if (this.sectionSub) {
            this.sectionSub.unsubscribe();
        }
    };
    ProfilePageComponent.prototype.onOptionChange = function (option) {
        this.activeOption = option;
    };
    ProfilePageComponent.prototype.onEdit = function () {
        this.editing = true;
    };
    ProfilePageComponent.prototype.onEditClose = function () {
        this.editing = false;
    };
    return ProfilePageComponent;
}());
export { ProfilePageComponent };
